import {IModelConfiguration, IMaterial} from "../model.schema";
import {useEffect, useState} from "react";
import {Option} from "@canvas-logic/engine";
import {availableMaterials} from "../services/engine-service";

export const useMaterialOptions = (configuration: IModelConfiguration|undefined) => {
    const [options, setOptions] = useState<Option<IMaterial>[]>([]);
    useEffect(() => {
        if(configuration) {
            const options = [...availableMaterials(configuration)];
            options.sort((a, b) => a.model.sort - b.model.sort);
            setOptions(options);
        }
    }, [configuration])

    return options;
}